import * as THREE from 'three'

class BackgroundSphere {
  constructor (props) {

    let defaults = {
      canvas: {},
      zoomFactor: 1
    }

    this.options = Object.assign(defaults, props)

    this.root = {}
    this.canvas = props.canvas
    this.failed = false

    this.canvasWidth = 700
    this.canvasHeight = 650
    this.aspectRatio = window.innerWidth / window.innerHeight

    this.scene = new THREE.Scene()

    let canvas = this.canvas

    this.renderer = new THREE.WebGLRenderer({ canvas })
    this.renderer.setPixelRatio(window.devicePixelRatio)
    this.renderer.setSize(window.innerWidth, window.innerHeight)

    this.windowHalfX = window.innerWidth / 2
    this.windowHalfY = window.innerHeight / 2
    this.mouseX = 0
    this.mouseY = 0

    this.textureLoader = new THREE.TextureLoader()
    this.textureEquirec = this.textureLoader.load(require('../../assets/img/Space.jpg'))
    this.textureEquirec.mapping = THREE.EquirectangularReflectionMapping;
    this.scene.background = this.textureEquirec

    const fov = 75;
    const near = 0.1;
    const far = 5;

    this.camera = new THREE.PerspectiveCamera(fov, this.aspectRatio, near, far)

    this.camera.lookAt(1000, 1000, 1000)

    this.camera.fov *= (1 / this.options.zoomFactor)
    this.camera.updateProjectionMatrix()

    if (!BackgroundSphere._instance) {
      BackgroundSphere._instance = this
    }

    return BackgroundSphere._instance
  }

  static getInstance () {
    return this._instance
  }

  initModel () {
    let self = this

    this.init()
    animate()

    function animate () {
      requestAnimationFrame(animate)
      self.render()
    }
  }

  init () {
    let self = this

    const ambientLight = new THREE.AmbientLight(0xffffff, 0.3)
    this.scene.add(ambientLight)

    this.scene.add(this.camera)

    // document.addEventListener('mousemove', (e) => {
    //   this.onDocumentMouseMove(e, self)
    // })
  }

  onDocumentMouseMove (event, self) {
    self.mouseX = (event.clientX - self.windowHalfX) / 2
    self.mouseY = (event.clientY - self.windowHalfY) / 2
  }

  render () {
    if(this.scene !== undefined) {
      this.scene.rotation.y += 0.001
    }

    this.renderer.render(this.scene, this.camera)
  }
}

export default BackgroundSphere
